export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10040.74ac8796.jpg";